import { render, staticRenderFns } from "./amountExpand.vue?vue&type=template&id=51774c21&"
import script from "./amountExpand.vue?vue&type=script&lang=js&"
export * from "./amountExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports